// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetRequestFormsRequestViewModel from '../../viewModel/request/RequestForms/GetRequestFormsRequestViewModel';
import StringListResultViewModel from '../../viewModel/resource/StringListResultViewModel';
import RequestFormResourcePagingResultViewModel from '../../viewModel/resource/RequestFormResourcePagingResultViewModel';
import RequestFormResourceViewModel from '../../viewModel/resource/RequestFormResourceViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getPaymentStates(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-payment-states'] ?? 'core/RequestForms/PaymentStates';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new StringListResultViewModel().fromDTO(dto);
  },
  /**  */
  async getPaymentTypes(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-payment-types'] ?? 'core/RequestForms/PaymentTypes';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new StringListResultViewModel().fromDTO(dto);
  },
  /**  */
  async getTypes(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-types'] ?? 'core/RequestForms/Types';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new StringListResultViewModel().fromDTO(dto);
  },
  /**  */
  async getSubTypes(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-sub-types'] ?? 'core/RequestForms/SubTypes';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new StringListResultViewModel().fromDTO(dto);
  },
  /**  */
  async getReminderStates(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-reminder-states'] ?? 'core/RequestForms/ReminderStates';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new StringListResultViewModel().fromDTO(dto);
  },
  /**  */
  async getRequestForms(request: GetRequestFormsRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-request-forms'] ?? 'core/RequestForms';
    const response = await service.get<any>(endpointPath, {
      query: {
        from: requestDTO.from,
        until: requestDTO.until,
        type: requestDTO.type,
        subType: requestDTO.subType,
        state: requestDTO.state,
        paymentType: requestDTO.paymentType,
        paymentState: requestDTO.paymentState,
        reminderState: requestDTO.reminderState,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return new RequestFormResourcePagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async getRequestFormById(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-request-form-by-id'] ?? 'core/RequestForms/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new RequestFormResourceViewModel().fromDTO(dto);
  },
});
